import axios, { AxiosError } from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { CompliancePackageData } from '../types/compliance';
import { logError } from '../utils/logger';

export const getOrganizationCompliancePackagesData = async (): Promise<CompliancePackageData> => {
    const url = pathfinder('compliance_packages_data_by_organization_id');
    try {
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        logError(error as AxiosError, `Failed to get organization packages data, route: [${url}]`);
        throw error;
    }
};
